/**
 * Звук на странице: звучит ОДИН источник.
 *
 * Источники — плитки витрин и лент (кнопка звука в баре CardMediaBar),
 * превью-ролик карточки в виджете, видео-обложка пина «Ваш стиль» и любой
 * видеоплеер MediaPlayer (лайтбокс «глазика», результаты студии, модал
 * карточки). Два звучащих ролика — каша (владелец 16.09: плитка, её
 * полноэкранный просмотр и превью виджета играли втроём), поэтому зазвучавший
 * источник объявляет об этом, а остальные глохнут: каждый звучащий слушает
 * событие и выключается, если заявка пришла не от него. Событие на window, а
 * не контекст: источники живут в разных деревьях (лента трендов, витрина,
 * виджет, портал лайтбокса).
 *
 * Явный выбор человека («хочу со звуком») запоминается на сессию — см.
 * cardSound.ts (claimTileSound / releaseTileSound). Автостарт со звуком
 * (лайтбокс, превью виджета по запомненному выбору) выбором не считается:
 * он только объявляет звук (announceTileSound), настройку не трогает.
 */
import { setSoundPref } from './cardSound'

const EVENT = 'umnik:tile-sound'

let seq = 0
/** Уникальная метка источника — выдаётся один раз на маунт. */
export function tileSoundToken(): number {
	seq += 1
	return seq
}

/** Источник зазвучал (автостарт, снятый mute): остальные глохнут. */
export function announceTileSound(token: number): void {
	window.dispatchEvent(new CustomEvent<number>(EVENT, { detail: token }))
}

/** Человек включил звук кнопкой: запоминаем выбор, остальные глохнут. */
export function claimTileSound(token: number): void {
	setSoundPref(true)
	announceTileSound(token)
}

export function releaseTileSound(): void {
	setSoundPref(false)
}

/** Подписка звучащего источника: колбэк зовётся, когда звук забрал другой. */
export function onTileSoundClaimed(token: number, lost: () => void): () => void {
	const handler = (e: Event) => {
		if ((e as CustomEvent<number>).detail !== token) lost()
	}
	window.addEventListener(EVENT, handler)
	return () => window.removeEventListener(EVENT, handler)
}
